export default "__VITE_ASSET__CrWLOprb__"